import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "../../../components/svgs";

const steps = [
  {
    number: "01",
    tag: "SOURCE",
    title: "Access relevant talent",
    desc: "Start with a clear role need and focused talent discovery.",
  },
  {
    number: "02",
    tag: "HIRE",
    title: "Decide with evidence",
    desc: "Review capability, human context and role fit before selection.",
  },
  {
    number: "03",
    tag: "ONBOARD",
    title: "Set up the engagement",
    desc: "Coordinate contracts, worker records and required documentation.",
  },
  {
    number: "04",
    tag: "PAY",
    title: "Run global workforce operations",
    desc: "Support payroll, payments and ongoing workforce needs.",
  },
];

const layers = [
  {
    title: "Compliance layer",
    desc: "Local context, classification and documentation",
  },
  {
    title: "Operations layer",
    desc: "Onboarding, records and workforce support",
  },
  {
    title: "Payment layer",
    desc: "Pay cycles, currencies and transaction visibility",
  },
];

const HomeWorkforceSection = () => {
  return (
    <section className="bg-white py-16 md:py-24 px-4" id="workforce">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="grid home-grid-1115 items-end gap-6 mb-10 md:mb-12">
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                Global workforce infrastructure
              </p>
              <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl">
                One product architecture for hiring and running global teams.
              </h2>
            </div>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Utiva Global Work connects talent access, compliant onboarding,
              workforce operations and payment in one coordinated offering.
            </p>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="rounded-hero overflow-hidden shadow-course-feature-lg">
            <div className="bg-primary px-6 py-5 sm:px-8 md:px-10 flex flex-wrap items-center justify-between gap-5">
              <div>
                <p className="text-secondary font-poppins tracking-[0.09em] text-xs font-extrabold mb-2">
                  UTIVA GLOBAL WORK
                </p>
                <h3 className="text-white font-poppins font-bold text-xl md:text-2xl m-0">
                  From talent need to every pay cycle
                </h3>
              </div>
              <span className="text-secondary font-poppins tracking-[0.09em] text-xs md:text-sm font-extrabold">
                CONNECTED PRODUCT OFFERING
              </span>
            </div>

            <div className="bg-hire-tint-blue px-6 py-8 sm:px-8 md:px-10 md:py-10">
              <div className="relative grid grid-cols-1 md:grid-cols-4 gap-3">
                {steps.map((step) => (
                  <article
                    key={step.number}
                    className="bg-white border border-hire-line rounded-2xl p-5 md:p-6"
                  >
                    <span className="inline-grid place-items-center w-10 h-10 rounded-lg bg-primary-light text-primary font-poppins font-bold text-sm mb-10 md:mb-6">
                      {step.number}
                    </span>
                    <p className="text-[#9a6500] font-poppins tracking-[0.09em] text-xs font-extrabold mb-2">
                      {step.tag}
                    </p>
                    <h4 className="text-primary font-poppins font-bold text-lg md:text-xl mb-2 leading-snug">
                      {step.title}
                    </h4>
                    <p className="text-gray text-sm font-poppins leading-[1.7] m-0">
                      {step.desc}
                    </p>
                  </article>
                ))}

                {[1, 2, 3].map((position) => (
                  <span
                    key={position}
                    className="hidden md:grid absolute z-10 top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-secondary text-primary place-items-center"
                    style={{ left: `${position * 25}%` }}
                    aria-hidden="true"
                  >
                    <ArrowRight fill="currentColor" />
                  </span>
                ))}
              </div>

              <div className="mt-10 md:mt-12">
                <p className="text-primary font-poppins tracking-[0.09em] text-sm font-extrabold uppercase mb-4">
                  Foundation layers
                </p>
                <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-hire-line bg-hire-tint-blue border border-hire-line rounded-2xl overflow-hidden">
                  {layers.map((layer) => (
                    <div key={layer.title} className="p-5 md:p-6">
                      <h5 className="text-primary font-poppins font-bold mb-1.5">
                        {layer.title}
                      </h5>
                      <p className="text-gray text-sm font-poppins m-0">
                        {layer.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-primary2 px-6 py-7 sm:px-8 md:px-10 md:py-8 flex flex-wrap items-center justify-between gap-5">
              <div>
                <p className="text-secondary font-poppins tracking-[0.09em] text-xs font-extrabold mb-2">
                  ONE CONNECTED VIEW
                </p>
                <p className="text-white font-poppins font-bold text-lg md:text-xl m-0">
                  Hire globally. Operate confidently. Support people
                  consistently.
                </p>
              </div>
              <Link
                to="/hire"
                className="bg-secondary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:-translate-y-0.5 transition-all"
              >
                Explore Global Work{" "}
                <span aria-hidden="true">
                  <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                </span>
              </Link>
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeWorkforceSection;
